import { FoxBizRequest, FoxRestBizClient } from "@/api/client";

/**
 * 채용공고 화면 관련 기능 클래스
 */
class Careers {

    /**
     * 생성자
     */
    constructor() {
        
    }

    /**
     * 채용공고 리스트
     * @param String dic 
     * @returns 
    */
    getRecruitNotice(dic) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Koreit.Biz.KRTBoardBiz';
            request.methodId = 'GetKRTBoardContentList';
            request.parameters.dic = dic;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                // const resultList = resultData.Table.rows;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 모집지원분야 / 전형절차 상세 항목 조회
     * @param {any} seq
     * @returns 
    */
    getNoticeOptions(seq) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'GetNoticeOptions';
            request.parameters.seq = seq;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 입사지원서 등록여부 조회
     * @param String dic 
     * @returns 
    */
    GetEnrollYN(dic) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'GetEnrollYN';
            request.parameters.dic = dic;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                // const resultList = resultData.Table.rows;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 입사지원서 상세 항목 조회
     * @param {String} formNo
     */
    getFormDetail(formNo) {
        return new Promise((resolve, reject) => {

            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'GetFormDetail';
            request.parameters.formNo = formNo;
            
            service.execute(request).then(response => {

                const tables = response.data.result.value;
                
                if (!!tables) resolve(tables);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 입사지원서 기본 정보 조회
     * @param String dic 
     * @returns 
    */
    GetEnrollApplication(dic) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'GetEnrollApplication';
            request.parameters.dic = dic;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 입사지원서 기본 정보 저장
     * @param String person 
     * @param String school 
     * @param String deleteCheck 
     * @param String deleteSchool 
     * @returns 
    */
    SaveEnrollApplication(person, school, deleteCheck, deleteSchool) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'SaveEnrollApplication';
            request.parameters.person = person;
            request.parameters.school = school;
            request.parameters.deleteCheck = deleteCheck;
            request.parameters.deleteSchool = deleteSchool;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 경력사항 조회
     * @param String dic 
     * @returns 
    */
    GetEnrollCareer(dic) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'GetEnrollCareer';
            request.parameters.dic = dic;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 경력사항 저장
     * @param String career 
     * @param String deleteCheck 
     * @param String deleteCareer  
     * @returns 
    */
    SaveEnrollCareer(career, deleteCheck, deleteCareer) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'SaveEnrollCareer';
            request.parameters.career = career;
            request.parameters.deleteCheck = deleteCheck;
            request.parameters.deleteCareer = deleteCareer;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 첨부파일 저장
     * @param string file 
     * @param String deleteCheck 
     * @param String deleteFile   
     * @returns 
    */
    SaveEnrollAttachFile(file, deleteCheck, deleteFile) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'SaveEnrollAttachFile';
            request.parameters.file = file;
            request.parameters.deleteCheck = deleteCheck;
            request.parameters.deleteFile = deleteFile;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 자격증/외국어/첨부파일 조회
     * @param String dic 
     * @returns 
    */
    GetEnrollCertifLangFile(dic) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'GetEnrollCertifLangFile';
            request.parameters.dic = dic;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 자격증 저장
     * @param string certif  
     * @param string deleteCheck  
     * @param string deleteCertif  
     * @returns 
    */
    SaveEnrollCertification(certif, deleteCheck, deleteCertif) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'SaveEnrollCertification';
            request.parameters.certif = certif;
            request.parameters.deleteCheck = deleteCheck;
            request.parameters.deleteCertif = deleteCertif;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 외국어 저장
     * @param string lang  
     * @param string deleteCheck  
     * @param string deleteLang  
     * @returns 
    */
    SaveEnrollForeignLang(lang, deleteCheck, deleteLang) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'SaveEnrollForeignLang';
            request.parameters.lang = lang;
            request.parameters.deleteCheck = deleteCheck;
            request.parameters.deleteLang = deleteLang;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }
    
    /**
     * 자기소개서 조회
     * @param String dic 
     * @returns 
    */
    GetEnrollEssay(dic) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'GetEnrollEssay';
            request.parameters.dic = dic;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 자기소개서 저장
     * @param string essay  
     * @returns 
    */
    SaveEnrollEssay(essay) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'SaveEnrollEssay';
            request.parameters.essay = essay;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 자기소개서 저장
     * @param string essay  
     * @returns 
    */
    SaveEnrollEssay(essay) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'SaveEnrollEssay';
            request.parameters.essay = essay;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 지원서 최종제출
     * @param string final  
     * @returns 
    */
    SaveEnrollFinal(final) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'SaveEnrollFinal';
            request.parameters.final = final;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 합격여부 목록 조회
     * @param String dic 
     * @returns 
    */
    GetConfirmNoticeList(dic) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'GetConfirmNoticeList';
            request.parameters.dic = dic;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 합격여부조회 대상자/합격여부 조회
     * @param String dic 
     * @returns 
    */
    GetApplicantPASS(dic) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Recruit.Biz.RecruitBiz';
            request.methodId = 'GetApplicantPASS';
            request.parameters.dic = dic;

            service.execute(request).then(response => {
                const resultData = response.data.result.value;
                if (!!response) resolve(
                    resultData
                );
                else resolve(null);
            }).catch(error => reject(error));
        });
    }
}

export const careers = new Careers();